angular.module('leanlaw').controller('ClientsQBSearchCtrl', ['$scope', '$q', '$window', '$location', '$stateParams', 'clientsservice', '$state', '$timeout', function ($scope, $q, $window, $location, $stateParams, clientsservice, $state, $timeout) {
  $scope.selectedFilter = 'Active';
  $scope.query = {
    name: ""
  };
  /* Alerts */
  $scope.editAlerts = [];
  $scope.addAlert = function (type, message) {
    var alert = {
      type: type,
      msg: message
    };
    console.log('Adding alert: ' + alert);
    $scope.editAlerts.push(alert);
    $timeout(function () {
      console.log('Removing alert: ' + alert);
      $scope.editAlerts.splice($scope.editAlerts.indexOf(alert), 1);
    }, 5000);
  };
  $scope.clientId = $stateParams.clientId;
  $scope.name = $stateParams.name;
  /* End Alerts */

  $scope.data = clientsservice.getDataModel();
  $scope.isLoading = true;
  clientsservice.getCustomersForSearch($scope.data, 1).then(function (d) {
    $scope.isLoading = false;
    $scope.data.qbCustomers = d.qbCustomers;
  });
  $scope.pagination = {
    current: 1
  };
  $scope.pageChanged = function (newPage) {
    if (!$scope.isLoading) getResultsPage(newPage);
  };
  function getResultsPage(pageNumber) {
    if ($scope.query.name.length < 3) {
      $scope.isLoading = true;
      clientsservice.getCustomersForSearch($scope.data, pageNumber).then(function (d) {
        $scope.isLoading = false;
        $scope.data.qbCustomers = d.qbCustomers;
      });
    } else {
      $scope.isLoading = true;
      clientsservice.searchCustomerData($scope.query.name, pageNumber).then(function (d) {
        $scope.isLoading = false;
        $scope.data.qbCustomers = d.qbCustomers;
      });
    }
  }
  $scope.searchList = function (e) {
    if ($scope.query.name.length >= 3) {
      $scope.isLoading = true;
      clientsservice.searchCustomerData($scope.query.name, 1).then(function (d) {
        $scope.isLoading = false;
        $scope.data.qbCustomers = d.qbCustomers;
      });
    } else if ($scope.query.name.length == 0) {
      $scope.isLoading = true;
      clientsservice.getCustomersForSearch($scope.data, 1).then(function (d) {
        $scope.isLoading = false;
        $scope.data.qbCustomers = d.qbCustomers;
      });
    }
  };
  $scope.filterOptions = ['Active', 'Archived'];
  $scope.associateClientToCustomer = function (id, displayName) {
    $scope.clientId = $scope.clientId === undefined ? '00000000-0000-0000-0000-000000000000' : $scope.clientId;
    $scope.isLoading = true;
    clientsservice.associateClientData(id, displayName, $scope.clientId, true).then(function (e) {
      if (e.message == "success") {
        clientsservice.getCustomersForSearch($scope.data, 1).then(function (d) {
          $scope.isLoading = false;
          $scope.goBack();
        });
      } else {
        $scope.isLoading = false;
        $scope.addAlert('warning', e.message);
      }
    });
  };
  $scope.goBack = function () {
    var url = "clients/";
    $scope.qbName = '';
    $scope.qbEmail = '';
    $scope.qbId = '';
    $scope.$emit('refreshTable', "");
    $location.url(url);
  };
  $scope.saveQbToClient = function (id) {
    bootbox.confirm("A new client record will be created for the selected QuickBooks customer if it is not already tied to an existing client.  Do you wish to proceed?", function (result) {
      if (result) {
        $scope.isLoading = true;
        clientsservice.saveQbToClientData(id).then(function (d) {
          $scope.addAlert('success', "Customer Imported");
          getResultsPage(1);
        });
      }
    });
  };
  $scope.$on('refreshTable', function (event, args) {
    $scope.selectedFilter = 'Active';
    $scope.getClients($scope.selectedFilter);
    $scope.addAlert('success', "Client saved");
  });
}]);